import { render, staticRenderFns } from "./rubric_library_view_list.vue?vue&type=template&id=183f0bbc&scoped=true&"
import script from "./rubric_library_view_list.vue?vue&type=script&lang=js&"
export * from "./rubric_library_view_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f0bbc",
  null
  
)

export default component.exports